import { ClientRow } from './ClientRow'
import type { Client } from '@/types/client'
import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react'

interface ClientsTableProps {
  clients: Client[]
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  onSort?: (col: string) => void
}

function SortIcon({ col, sortBy, sortOrder }: { col: string; sortBy?: string; sortOrder?: 'asc' | 'desc' }) {
  if (sortBy !== col) return <ChevronsUpDown className="w-3.5 h-3.5 opacity-40" />
  return sortOrder === 'asc'
    ? <ChevronUp className="w-3.5 h-3.5 text-mint-600" />
    : <ChevronDown className="w-3.5 h-3.5 text-mint-600" />
}

export function ClientsTable({ clients, sortBy, sortOrder, onSort }: ClientsTableProps) {
  const th = (label: string, col: string | null, align: 'left' | 'right' = 'left') => (
    <th
      className={`text-${align} px-4 py-3 text-xs font-medium text-brown-500 uppercase tracking-wider whitespace-nowrap ${col && onSort ? 'cursor-pointer select-none hover:text-brown-700' : ''}`}
      onClick={col && onSort ? () => onSort(col) : undefined}
    >
      <span className={`inline-flex items-center gap-1 ${align === 'right' ? 'justify-end w-full' : ''}`}>
        {label}
        {col && onSort && <SortIcon col={col} sortBy={sortBy} sortOrder={sortOrder} />}
      </span>
    </th>
  )

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-beige-50 border-b border-beige-200">
          <tr>
            {th('Client', 'full_name')}
            {th('Email', 'email')}
            {th('Telephone', null)}
            {th('Type', 'type_client')}
            {th('Entreprise', 'company')}
            {th('Projets', null)}
            {th('Factures', null)}
            {th('Cree le', 'created_at')}
            {th('Actions', null, 'right')}
          </tr>
        </thead>
        <tbody className="divide-y divide-beige-200">
          {clients.map((client) => (
            <ClientRow key={client.id} client={client} />
          ))}
        </tbody>
      </table>
    </div>
  )
}
